module.exports = new __parcel__URL__("icyshards.7f617c75.png").toString();